export default {
    namespaced: true,
    state: {
        select_player: null, // выбранный игрок
        count_substitute_players: 0, // кол-во замещающих игроков
    },
    getters: {
        /**
         * возвращает данные о выбранном игроке
         * @param state - объект Состояние, хранит данные доступные для приложения
         * @returns {boolean|null}
         */
        getSelectPlayer: (state) => state.select_player,
        /**
         * возвращает кол-во замещающих игроков
         * @param state - объект Состояние, хранит данные доступные для приложения
         * @returns {number}
         */
        getCountSubstitutePlayers: (state) => state.count_substitute_players,
    },
    mutations: {
        /**
         * мутация, записывает в счетчик замещающих игроков
         * @param state
         * @constructor
         */
        ADD_COUNT_SUBSTITUTE_PLAYERS(state) {
            state.count_substitute_players += 1;
        },
        /**
         * мутация, сбрасывает счетчик замещающих игроков
         * @param state
         * @constructor
         */
        RESET_COUNT_SUBSTITUTE_PLAYERS(state) {
            state.count_substitute_players = 0;
        },
        /**
         * мутация, записывает выбранного игрока в select_player
         * @param state - объект Состояние, хранит данные доступные для приложения
         * @param player - игрок
         * @constructor
         */
        SET_SELECT_PLAYER(state, player) {
            state.select_player = player;
        },
        /**
         * мутация, записывает игрока, который замещает выбранного игрока (select_player)
         * @param state - объект Состояние, хранит данные доступные для приложения
         * @param player - игрок
         * @constructor
         */
        SET_SUBSTITUTE_PLAYER(state, player) {
            state.select_player.substitute_player = player;
        },
        /**
         * мутация, сбрасывает объект "select_player" - на null
         * @param state - объект Состояние, хранит данные доступные для приложения
         * @constructor
         */
        RESET_SELECT_PLAYER(state) {
            state.select_player = null;
        },
    },
    actions: {
        /**
         * функция глобального хранилища для вызова мутации (ADD_COUNT_SUBSTITUTE_PLAYERS, SET_SUBSTITUTE_PLAYER)
         * @param commit - внутренняя функция для вызова мутаций, изменение состояния глобальных объектов
         * @param state - объект Состояние, хранит данные доступные для приложения
         * @param player - игрок
         * @returns {Promise<void>}
         * @constructor
         */
        SET_SUBSTITUTE_PLAYER({ commit, state }, player) {
            if (!state.select_player.substitute_player) {
                commit("ADD_COUNT_SUBSTITUTE_PLAYERS");
            }
            commit("SET_SUBSTITUTE_PLAYER", player);
        },
        /**
         * функция глобального хранилища для вызова мутации (RESET_SELECT_PLAYER, RESET_COUNT_SUBSTITUTE_PLAYERS)
         * @param commit - внутренняя функция для вызова мутаций, изменение состояния глобальных объектов
         * @constructor
         */
        RESET_SELECT_PLAYER({ commit }) {
            commit("RESET_SELECT_PLAYER");
            commit("RESET_COUNT_SUBSTITUTE_PLAYERS");
        },
    },
};
